/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "agenda": {
        "nested": {
          "ClientMessage": {
            "fields": {
              "customClientMessageBody": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "sendSms": {
                "type": "bool",
                "id": 2,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "sendEmail": {
                "type": "bool",
                "id": 3,
                "rule": "optional",
                "options": {
                  "default": false
                }
              },
              "sendCustomClientMessageBodyToClient": {
                "type": "bool",
                "id": 4,
                "rule": "optional",
                "options": {
                  "default": false
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.agenda?.nested?.ClientMessage) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ClientMessage @ squareup/agenda/common.proto at 13:1
 */
export const ClientMessage = $root.lookupType('squareup.agenda.ClientMessage');
fixType(ClientMessage);
Builder.createAndAttachToType(ClientMessage);